<template>
  <div
    class="m-dropdown-content m-dropdown-content-left"
    id="MoleculeEditionBillingMyChargesDropDownFilters"
  >
    <form @submit.prevent="btnFilter">
      <section class="m-dropdown-section">
        <ul class="m-dropdown-list">
          <li>
            <a href="#">
             {{ $t('mEditionBillingMyChargesDropDownFilters.input.estado.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <ul>
                <li>
                  <label>
                    <input
                      v-model="filter.estado"
                      name="estado"
                      type="checkbox"
                      value="3"
                    >
                    {{ $t('mEditionBillingMyChargesDropDownFilters.input.estado.cancelado.label') }}
                  </label>
                </li>
                <li>
                  <label>
                    <input
                      v-model="filter.estado"
                      name="estado"
                      type="checkbox"
                      value="2"
                    >
                    {{ $t('mEditionBillingMyChargesDropDownFilters.input.estado.cobrado.label') }}
                  </label>
                </li>
                <li>
                  <label>
                    <input
                      v-model="filter.estado"
                      name="estado"
                      type="checkbox"
                      value= "0"
                    >
                    {{ $t('mEditionBillingMyChargesDropDownFilters.input.estado.pendiente.label') }}
                  </label>
                </li>
                <li>
                  <label>
                    <input
                      v-model="filter.estado"
                      name="estado"
                      type="checkbox"
                      value="1"
                    >
                    {{ $t('mEditionBillingMyChargesDropDownFilters.input.estado.reembolso.label') }}
                  </label>
                </li>
              </ul>
            </div>
          </li>
          <ul class="m-dropdown-list">
          <li>
            <a href="#">
              {{ $t('mEditionBillingMyChargesDropDownFilters.input.pais.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomSelectPrimary
                :elements="paises"
                key-field="id_pais"
                name="pais"
                reference="pais"
                text-field="nombre"
                @change="setIdPais"
              />
            </div>
          </li>
        </ul>
          <li>
            <a href="#">
              {{ $t('mEditionBillingMyChargesDropDownFilters.input.divisa.label') }}
            </a>
            <div class="m-dropdown-sublist m-dropdown-sublist-scrollable">
              <ul>
                <li
                  v-for="(divisa, index) in divisas"
                  :key="index"
                >
                  <label>
                    <input
                      v-model="filter.divisa"
                      name="moneda"
                      type="checkbox"
                      :value="divisa.id_divisa"
                    >
                    {{divisa.nombre}}
                  </label>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <a href="#">
             {{ $t('mEditionBillingMyChargesDropDownFilters.input.medioPago.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <ul>
                <li
                  v-for="(pasarela, index) in pasarelasPago"
                  :key="index"
                >
                  <label>
                    <input
                      v-model="filter.pasarela_pago"
                      type="checkbox"
                      name="medio"
                      :value="pasarela.id">
                    {{pasarela.nombre}}
                  </label>
                </li>
              </ul>
            </div>
            <ul class="m-dropdown-list">
          <li>
            <a href="#">
              {{ $t('mEditionBillingMyChargesDropDownFilters.input.email.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <input
                class="a-input-primary"
                name="email"
                v-model="filter.buscar"
                :placeholder="$t('mEditionBillingMyChargesDropDownFilters.input.email.placeholder')"
                type="text"
              />
            </div>
          </li>
        </ul>
          </li>
          <li>
            <a href="#">
              {{ $t('mEditionBillingMyChargesDropDownFilters.input.fecha.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <input
                v-model="filter.fecha_desde"
                class="a-input-primary"
                name="desde"
                :placeholder="$t('mEditionBillingMyChargesDropDownFilters.input.fecha.desde.placeholder')"
                type="text"
              >
              <input
                v-model="filter.fecha_hasta"
                class="a-input-primary"
                name="hasta"
                :placeholder="$t('mEditionBillingMyChargesDropDownFilters.input.fecha.hasta.placeholder')"
                type="text"
              >
            </div>
          </li>
          <li>
            <a href="#">
              {{ $t('mEditionBillingMyChargesDropDownFilters.input.descuento.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <input
                v-model="filter.cupon"
                class="a-input-primary"
                name="descuento"
                placeholder="Escribe aquí un código"
                type="text"
              >
            </div>
          </li>
        </ul>
      </section>
      <footer class="m-dropdown-footer">
        <button
          class="a-button-dropdown-secondary"
          @click="btnReiniciar"
        >
         {{ $t('mEditionBillingMyChargesDropDownFilters.buttons.btnReiniciarText') }}
        </button>
        <button
          class="a-button-primary a-button-billing-primary a-button-dropdown-primary"
        >
          {{ $t('mEditionBillingMyChargesDropDownFilters.buttons.btnFilterText') }}
        </button>
      </footer>
    </form>
  </div>
</template>
<script>
export default {
  name: 'MoleculeEditionBillingMyChargesDropDownFilters',

  data () {
    return {
      filter: {
        buscar: '',
        fecha_desde: '',
        fecha_hasta: '',
        pais: '',
        divisa: [],
        pasarela_pago: [],
        estado: [],
        cupon: '',
        sort_by: '',
        order: '',
        pagina: 1,
        limite: this.$paginate.getXpage()
      },
      divisas: [],
      pasarelasPago: [],
      comprobantesTipo: [],
      paises: []
    }
  },

  created () {
    this.readParametroPaises()
    this.readComprobanteTipos(1)
    this.readDivisas()
    this.readPasarelasPagoActivas()
  },

  methods: {
    btnFilter () {
      this.$emit('set-filter', this.filter)
    },

    btnReiniciar () {
      this.filter = {
        buscar: '',
        fecha_desde: '',
        fecha_hasta: '',
        pais: '',
        divisa: [],
        pasarela_pago: [],
        estado: [],
        cupon: '',
        sort_by: '',
        order: '',
        pagina: 1,
        limite: this.$paginate.getXpage()
      }
    },

    readComprobanteTipos (idPais) {
      this.$services.read('comprobante', 'readComprobanteTipos', {}, [idPais])
        .then(response => {
          this.comprobantesTipo = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },

    readDivisas () {
      this.$services.read('divisa', 'readDivisas')
        .then(response => {
          this.divisas = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },

    readParametroPaises () {
      this.$services.read('parametro', 'readParametroPaises')
        .then(response => {
          this.paises = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },

    readPasarelasPagoActivas () {
      this.$services.read('pasarela', 'readPasarelas')
        .then(response => {
          this.pasarelasPago = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },

    setIdPais (events) {
      this.filter.pais = event.target.value
      this.readComprobanteTipos(this.filter.pais)
    }
  }
}
</script>
